import { Player } from '@lottiefiles/react-lottie-player'
import loader from '../../assets/config/loader.json'
import { FC } from 'react'

interface SpinnerProps {
  className?: string
}

export const Spinner: FC<SpinnerProps> = (props) => {
  const { className } = props
  return (
    <Player
      autoplay
      loop
      src={loader}
      style={{ height: '300px', width: '300px' }}
      className={className}
    />
  )
}
